<template>
</template>

<script>
  export default {
    name: "Logout",
    components: {
    },
    data() {
      return {
      }
    },
    methods: {
    },
    created() {
      this.$store.commit('clear');
      this.$store.commit('setlogin', false);
      this.$router.push("/");
    }
  }
</script>

<style scoped>
</style>
